import { jwtDecode } from 'jwt-decode';
import { SIGN_IN_STATE, SIGN_IN_CHECK, RESET_SIGN_IN_STATE } from './types';
import { refresh } from './account-actions';
import { setupStore } from '../components/store';
import { isValidEmail } from '../components/utilities/validations';

const store = setupStore();

const setSignInState = (access_token = null, customerType = null) => {
	if (access_token) {
		const user = jwtDecode(access_token);
		store.dispatch({
			type: SIGN_IN_STATE,
			payload: {
				firstname: user.firstname,
				email: isValidEmail(user.prn) ? user.prn.toLowerCase() : user.mail ? user.mail.toLowerCase() : '',
				...customerType,
			},
		});
	} else {
		store.dispatch({
			type: RESET_SIGN_IN_STATE,
		});
	}
};

const checkSignInState = async () => {
	try {
		const result = await refresh();

		store.dispatch({
			type: SIGN_IN_CHECK,
		});

		return result;
	} catch (error) {
		store.dispatch({
			type: SIGN_IN_CHECK,
		});
	}
};

export { setSignInState, checkSignInState };
